import { useMutation, useQueryClient } from 'react-query';
import {
  createAdaptedFictionEditionComment,
  type CreateAdaptedFictionEditionCommentBody,
  type CreateAdaptedFictionEditionCommentResponse
} from '../../services/commentsAndLikeService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useCreateAdaptedFictionEditionComment({
  adaptedFictionEditionId
}: {
  adaptedFictionEditionId: string;
}) {
  const queryClient = useQueryClient();
  return useMutation<
    CreateAdaptedFictionEditionCommentResponse,
    Error,
    CreateAdaptedFictionEditionCommentBody
  >({
    mutationFn: (body) => createAdaptedFictionEditionComment({ adaptedFictionEditionId, body }),
    onSuccess: () => {
      queryClient.invalidateQueries(
        SCENE_QUERY_KEYS.adaptedFictionEditionComments(adaptedFictionEditionId)
      );
      const targetId = adaptedFictionEditionId;

      queryClient.setQueriesData(SCENE_QUERY_KEYS.adaptedFictionPreviews, (oldPreviews) => {
        if (!oldPreviews) return oldPreviews;

        return {
          ...oldPreviews,
          pages: (
            oldPreviews as {
              pages: Array<
                Array<{ adaptedFictionEditionId: string; isLiked: boolean; commentsCount: number }>
              >;
            }
          ).pages.map(
            (
              page: Array<{
                adaptedFictionEditionId: string;
                isLiked: boolean;
                commentsCount: number;
              }>
            ) => {
              return page.map((post) => {
                if (post.adaptedFictionEditionId === targetId) {
                  return {
                    ...post,
                    commentsCount: (post.commentsCount ?? 0) + 1
                  };
                }
                return post;
              });
            }
          )
        };
      });
    }
  });
}
